import { FC } from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import styles from './FormInputText.scss';

interface InputProps {
  name: string;
  placeholder?: string;
  control: any;
  type?: string;
  error?: boolean;
}

export const FormInputText: FC<InputProps> = ({
  name,
  placeholder = '',
  control,
  type = '',
  error = false,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField
          className={styles.input}
          placeholder={placeholder}
          type={type}
          error={error}
          {...field}
        />
      )}
    />
  );
};
